import PropTypes from 'prop-types';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

import FieldRepeater from '..';
import FieldRepeaterCFormik from './FieldRepeaterCFormik';
import FieldRepeaterCDefault from './FieldRepeaterCDefault';

const FieldRepeaterCText = (props) => {
	const { formik = true, onChange, fieldParams = {}, ...rest } = props;
	const repeatShape = '';

	const linesConvertor = (name) => (option, i) => {
		return {
			props: {
				type: FORM_LINE_TYPES.textfield,
				connected: formik,
				params: {
					name: `${name}.${i}`,
					value: formik ? undefined : option,
					onChange,
					...fieldParams,
				},
			},
		};
	};

	const Comp = formik ? FieldRepeaterCFormik : FieldRepeaterCDefault;

	return (
		<Comp repeatShape={repeatShape} linesConvertor={linesConvertor} {...rest} />
	);
};

FieldRepeaterCText.propTypes = {
	...FieldRepeater.propTypes,
	formik: PropTypes.bool,
	onChange: PropTypes.func,
	fieldParams: PropTypes.object,
};

export default FieldRepeaterCText;
